module.exports = __webpack_public_path__ + "media/img/help_center/Student_Message_03-381d5d6a06ca3df9775ca8a3d26a3202.jpg";